<template>
	<div class="">
		<div class="row">
	    <div class="col-md-12">
          <b-card no-body class="box-shadow">
            <b-tabs>
              <b-tab title="Info" v-if="can_access('customer','view')">
                  <div class="wrapper wrapper-content animated fadeInUp">
                      <div class="ibox">
                          <div class="ibox-content">
                              <div class="row">
                                  <div class="col-lg-12">
                                      <div class="m-b-md">
                                        <h4>Basic Info</h4>
                                          <div class="row">
                                            <div class="col-lg-5">
                                              <dl class="dl-horizontal">
                                                <dt>Account No :</dt> <dd>{{row.account_number?row.account_number:'-'}}</dd>
                                                <dt>Name :</dt> <dd>{{row.title}} {{row.firstname}} {{row.lastname}}</dd>
                                                <dt>Email :</dt> <dd><a href="#" class="text-navy">{{row.email?row.email:'-'}}</a> </dd>
                                            </dl>
                                        </div>
                                        <div class="col-lg-7" id="cluster_info">
                                          <dl class="dl-horizontal">
                                            <dt>Status :</dt> <dd><span class="label label-primary" :style="row.status?'color:green':'color:red'">{{row.status?'Active':'Inactive'}}</span></dd>
                                            <dt>Phone No :</dt> <dd>  {{row.phone_no||'-'}}</dd>
                                                <dt>DOB/Incorporation Date :</dt> <dd>{{row.dob?row.dob:'-'}}</dd>
                                            </dl>
                                        </div>
                                    </div>
                                      </div>
                                  </div>
                              </div>
                              <h4 v-if="clustered_info_1.length">Other Info</h4>
                              <div class="row">
                                  <div class="col-lg-5">
                                      <dl class="dl-horizontal">
                                          <span v-for="info in clustered_info_1"><dt :title="info.title">{{info.title}} :</dt> <dd>{{info.value}}</dd></span>
                                      </dl>
                                  </div>
                                  <div class="col-lg-7" id="cluster_info">
                                      <dl class="dl-horizontal">
                                          <span v-for="info in clustered_info_2"><dt :title="info.title">{{info.title}} :</dt> <dd>{{info.value}}</dd></span>
                                      </dl>
                                  </div>
                              </div>
                              <!-- <div class="row">
                                  <div class="col-lg-12">
                                    <button class="btn btn-lg btn-info pull-right">Approve</button>
                                  </div>
                              </div> -->
                              <!-- <div class="row">
                                  <div class="col-lg-12">
                                      <dl class="dl-horizontal">
                                          <dt>Completed:</dt>
                                          <dd>
                                              <div class="progress progress-striped active m-b-sm">
                                                  <div style="width: 60%;" class="progress-bar"></div>
                                              </div>
                                              <small>Project completed in <strong>60%</strong>. Remaining close the project, sign a contract and invoice.</small>
                                          </dd>
                                      </dl>
                                  </div>
                              </div> -->
                          </div>
                      </div>
                  </div>
              </b-tab>
              <b-tab title="Uploaded Docs" v-if="can_access('customer','modify')">
                <div class="wrapper wrapper-content project-manager">
                  <h5>Uploaded Docs</h5>
                  <ul class="list-unstyled project-files">
                      <dl v-for="doc in row_detail.docs"  class="dl-horizontal">
                        <dt style="width:360px;text-align:left;">
                          <a :title="doc.doc_name" :href="get_baseURL()+doc.doc_path" target="_blank"><i class="fa fa-file"></i> {{doc.doc_name}}</a>
                        </dt>
                        <dd style="margin-left:380px">
                          <a href="javascript:;" ><span v-if="doc.doc_status==0" style="color:blue">Pending</span>
                          <span v-else-if="doc.doc_status==1" style="color:green">Verified</span>
                          <span v-else-if="doc.doc_status==2" style="color:red">Not-Verified</span></a>
                        </dd>
                      </dl>
                  </ul>
                  <div class="text-center m-t-md">
                      <a href="javascript:;" class="btn btn-xs btn-primary" @click="nested.$toggle('UploadDocs', true)">Add files</a>
                  </div>
                </div>  
              </b-tab>
            </b-tabs>
          </b-card>
	    </div>

	    <!-- <div class="col-md-3">
	        <div class="wrapper wrapper-content project-manager">
	            <h5>Uploaded Docs</h5>
	            <ul class="list-unstyled project-files">
	                <li><a href=""><i class="fa fa-file"></i> Project_document.docx</a><p style="float:right">verified</p></li>
	            </ul>
	            <div class="text-center m-t-md">
	                <a href="javascript:;" class="btn btn-xs btn-primary" @click="nested.$toggle('UploadDocs', true)">Add files</a>
	            </div>
	        </div>
	    </div> -->
		</div>
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {},
  mixins: [common],
  props: ['row','nested'],
  data(){
  	return {
      row_detail: [],
  		clustered_info_1: [],
  		clustered_info_2: [],
      columns: (() => {
        const cols = [
          { title: 'Contract Note', field: 'contract_note', label: 'User ID', visible: 'true' },
          { title: 'Ticket Number', field: 'ticket_number' },
          { title: 'Ticker', field: 'stock', 'nested': 'tidm'},
          { title: 'Quantity', field: 'quantity'},
          { title: 'Type', field: 'type'},
          { title: 'Currency', field: 'currency'},
          { title: 'Trade Price', field: 'trade_price', sortable: true },
          { title: 'Trade Value', field: 'trade_value', sortable: true},
          { title: 'Trade Date', field: 'trade_date', sortable: true },
          { title: 'Settlement Date', field: 'settlement_date', sortable: true },
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  async created() {
    await this.getData().then(({response})=>{this.row_detail = response.data.result[0];this.cluster_info()});
  },
  methods: {
  	cluster_info(){
  		let other_infos = [
  			{ title: 'Alt. Phone Number', field: 'alt_phone_no'},
  			{ title: 'NI/LEI Number', field: 'ni_number'},
  			{ title: 'Address', field: 'address'},
  			{ title: 'City', field: 'city'},
  			{ title: 'State', field: 'state'},
  			{ title: 'Country', field: 'country'},
  			{ title: 'Zip', field: 'zip'},
  			{ title: 'No. Of Years In Address', field: 'no_of_years_in_address'},
  			{ title: 'Education', field: 'education'},
  			{ title: 'Employee Status', field: 'employee_status'},
  			{ title: 'Occupation', field: 'occupation'},
  			{ title: 'Employee Sector', field: 'employment_sector'},
  			{ title: 'Annual Income', field: 'annual_income'},
  			{ title: 'Size Of Investment', field: 'size_of_investment'},
  			{ title: 'Funding Method', field: 'funding_method'},
  			{ title: 'Security Type', field: 'security_type'},
  			{ title: 'How Much You Invest Per Year', field: 'how_much_you_invest_per_year'},
  			{ title: 'How Do You Know About Us', field: 'how_do_you_know_about_us'},
  			{ title: 'Initial Deposit Amount', field: 'initial_deposit_amount'},
  			{ title: 'How Many Trades In Shares', field: 'how_many_trades_in_shares'},
  			{ title: 'How Many Trades In FX', field: 'how_many_trades_in_fx'},
  			{ title: 'How Many Trades In Equity Derivatives', field: 'how_many_trades_in_equity_derivatives'},
  			{ title: 'Have Req Knowledge In Trade', field: 'have_req_knowledge_in_trade'},
  			{ title: 'Have Trained For Training', field: 'have_trained_for_trade'},
  			{ title: 'Bank Account Name', field: 'bank_account_name'},
  			{ title: 'Bank Account Number', field: 'bank_account_number'},
  			{ title: 'Bank Account Sort Code', field: 'bank_account_sort_code'},
  			{ title: 'Read Terms And Conditions', field: 'read_terms_and_condtn'},
  			{ title: 'Read Warning Notice', field: 'risk_warning_notice'},
  			{ title: 'Read Privacy Policy', field: 'read_privacy_policy'},
  			{ title: 'We W\'ont Provide Advice In Trading', field: 'wont_provide_advice_in_trading'},
  			{ title: 'TTCA Agreement', field: 'TTCA_agreement'},
  		];
  		let infos = other_infos.filter(info => {
  			return (this.row_detail.hasOwnProperty('other_details') && this.row_detail.other_details.hasOwnProperty(info.field) && this.row_detail.other_details[info.field]) || (this.row_detail.hasOwnProperty(info.field) && this.row_detail[info.field]);
  		});
  		infos.forEach((value , key) => {
  			if(infos.length/2<key){ this.clustered_info_2.push({title: value.title, value: this.row_detail.hasOwnProperty(value.field) ? this.row_detail[value.field] : this.row_detail.other_details[value.field]}) }
  			else{ this.clustered_info_1.push({title: value.title, value: this.row_detail.hasOwnProperty(value.field) ? this.row_detail[value.field] : this.row_detail.other_details[value.field]}) }
  		});
  	},
    async getData() {
      var limit = 10, offset = 0, sort = '', order = '' ;
      var filter = {};
      filter['account_number'] = this.row.account_number;
      /* this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined'){
          delete filter[col.field];
        }
      }); */
      let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter)+'&full_detail=1';
      return await this.call_axios(uri);
    }
  }
}
</script>
<style>
body{margin-top:20px;
background:#eee;
}
/* PROJECTS */
.project-people,
.project-actions {
  text-align: right;
  vertical-align: middle;
}
dd.project-people {
  text-align: left;
  margin-top: 5px;
}
.project-people img {
  width: 32px;
  height: 32px;
}
.project-title a {
  font-size: 14px;
  color: #676a6c;
  font-weight: 600;
}
.project-list table tr td {
  border-top: none;
  border-bottom: 1px solid #e7eaec;
  padding: 15px 10px;
  vertical-align: middle;
}
.project-manager .tag-list li a {
  font-size: 10px;
  background-color: white;
  padding: 5px 12px;
  color: inherit;
  border-radius: 2px;
  border: 1px solid #e7eaec;
  margin-right: 5px;
  margin-top: 5px;
  display: block;
}
.project-files li a {
  font-size: 11px;
  color: #676a6c;
  margin-left: 10px;
  line-height: 22px;
}

/* PROFILE */
.profile-content {
  border-top: none !important;
}
.profile-stats {
  margin-right: 10px;
}
.profile-image {
  width: 120px;
  float: left;
}
.profile-image img {
  width: 96px;
  height: 96px;
}
.profile-info {
  margin-left: 120px;
}
.feed-activity-list .feed-element {
  border-bottom: 1px solid #e7eaec;
}
.feed-element:first-child {
  margin-top: 0;
}
.feed-element {
  padding-bottom: 15px;
}
.feed-element,
.feed-element .media {
  margin-top: 15px;
}
.feed-element,
.media-body {
  overflow: hidden;
}
.feed-element > .pull-left {
  margin-right: 10px;
}
.feed-element img.img-circle,
.dropdown-messages-box img.img-circle {
  width: 38px;
  height: 38px;
}
.feed-element .well {
  border: 1px solid #e7eaec;
  box-shadow: none;
  margin-top: 10px;
  margin-bottom: 5px;
  padding: 10px 20px;
  font-size: 11px;
  line-height: 16px;
}
.feed-element .actions {
  margin-top: 10px;
}
.feed-element .photos {
  margin: 10px 0;
}
.feed-photo {
  max-height: 180px;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
  margin-bottom: 10px;
}
.file-list li {
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 2px;
  border: 1px solid #e7eaec;
  margin-bottom: 5px;
}
.file-list li a {
  color: inherit;
}
.file-list li a:hover {
  color: #1ab394;
}
.user-friends img {
  width: 42px;
  height: 42px;
  margin-bottom: 5px;
  margin-right: 5px;
}

.ibox {
  clear: both;
  margin-bottom: 25px;
  margin-top: 0;
  padding: 0;
}
.ibox.collapsed .ibox-content {
  display: none;
}
.ibox.collapsed .fa.fa-chevron-up:before {
  content: "\f078";
}
.ibox.collapsed .fa.fa-chevron-down:before {
  content: "\f077";
}
.ibox:after,
.ibox:before {
  display: table;
}
.ibox-title {
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  background-color: #ffffff;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
.ibox-footer {
  color: inherit;
  border-top: 1px solid #e7eaec;
  font-size: 90%;
  background: #ffffff;
  padding: 10px 15px;
}
ul.notes li,
ul.tag-list li {
  list-style: none;
}
                                    
</style>
